// Ontario / Canada-wide statutory holidays for the next 2 years.
// These are observed dates (e.g., when a holiday falls on a weekend it can be
// observed on the next Monday — the federal/provincial rule varies).
// We pre-compute and freeze them here so the admin can import in one click.

export const CA_HOLIDAYS = [
    // ---------- 2026 ----------
    { date: "2026-01-01", name: "New Year's Day" },
    { date: "2026-02-16", name: "Family Day" },
    { date: "2026-04-03", name: "Good Friday" },
    { date: "2026-05-18", name: "Victoria Day" },
    { date: "2026-07-01", name: "Canada Day" },
    { date: "2026-08-03", name: "Civic Holiday" },
    { date: "2026-09-07", name: "Labour Day" },
    { date: "2026-10-12", name: "Thanksgiving Day" },
    { date: "2026-12-25", name: "Christmas Day" },
    { date: "2026-12-26", name: "Boxing Day" },

    // ---------- 2027 ----------
    { date: "2027-01-01", name: "New Year's Day" },
    { date: "2027-02-15", name: "Family Day" },
    { date: "2027-03-26", name: "Good Friday" },
    { date: "2027-05-24", name: "Victoria Day" },
    { date: "2027-07-01", name: "Canada Day" },
    { date: "2027-08-02", name: "Civic Holiday" },
    { date: "2027-09-06", name: "Labour Day" },
    { date: "2027-10-11", name: "Thanksgiving Day" },
    { date: "2027-12-25", name: "Christmas Day" },
    { date: "2027-12-26", name: "Boxing Day" },
];

export function upcomingHolidays(fromIso) {
    const today = fromIso || new Date().toISOString().slice(0, 10);
    return CA_HOLIDAYS.filter((h) => h.date >= today);
}
